module.exports = __webpack_public_path__ + "7811811ea26efd2312300b941348c505.png";